import { useEffect, useState } from "react";

/**
 * Reusable hook for maintaining order by fields for a sortable table
 *
 * @param {Object} columns    the table columns configuration
 */
const useSortableTable = (columns) => {
  const [orderBy, setOrderBy] = useState({});
  const [orderByFilter, setOrderByFilter] = useState("");

  useEffect(() => {
    setOrderByFilter(
      Object.keys(orderBy)
        .map((key) => `${key} ${orderBy[key]}`)
        .join(", ")
    );
  }, [orderBy]);

  const handleSortClick = (key, sortDirection) => {
    const orderByField = columns[key].orderByKey || key;
    const tempOrderBy = { ...orderBy };

    if (sortDirection === "none") delete tempOrderBy[orderByField];
    else tempOrderBy[orderByField] = sortDirection;

    setOrderBy(tempOrderBy);
  };

  return [orderByFilter, handleSortClick];
};

export default useSortableTable;
